import { Component, effect, input, output, Signal, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiInterfaceModel } from '../../../models/resources/api-interface.model';
import { FormInputComponent } from '../../utils/form-input/form-input.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-api-interface-form',
  imports: [
    ReactiveFormsModule,
    FormInputComponent,
    TranslateModule
  ],
  templateUrl: './api-interface-form.component.html',
  styleUrl: './api-interface-form.component.scss'
})
export class ApiInterfaceFormComponent {
  formGroupOutput = output<FormGroup>();
  formGroup: Signal<FormGroup>;
  apiInterface = input<ApiInterfaceModel>();

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = signal(this.formBuilder.group({
      name: [null, []],
      apiToken: [null, []],
      erpUrl: [null, []]
    }));

    effect(() => {
      this.formGroupOutput.emit(this.formGroup());
    });
    effect(() => {
      if (this.apiInterface()) {
        this.updateFormValues();
      }
    });
  }

  updateFormValues() {
    const currentModel = this.apiInterface();
    if (currentModel) {
      this.formGroup().patchValue({
        name: currentModel.name,
        apiToken: currentModel.apiToken ?? null,
        erpUrl: currentModel.erpUrl
      });
    }
  }
}
